<div class="flex pb-3">
    <textarea
    pInputTextarea
    [(ngModel)]="motivoAnulacion"
    placeholder="Escriba aquí el motivo..."
    rows="5"
    class="w-full p-3 border-2 border-gray-200 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-colors duration-200"
  >
  </textarea>
</div>

<div class="flex justify-end gap-2">
  <p-button
    type="button"
    label="Cancelar"
    icon="icon-cross"
    severity="danger"
    outlined
    (click)="cancelarModal()"
  >
  </p-button>

  <p-button
    type="button"
    label="Aceptar"
    icon="icon-switch"
    severity="success"
    outlined
    [disabled]="!motivoAnulacion || motivoAnulacion.trim().length === 0"
    (click)="confirmarAnulacion()"
  >
  </p-button>
</div>
